import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import UpdateMailingMethodBlockData from 'Models/Content/UpdateMailingMethodBlockData';
import MailingMethodMain from './MailingMethodMain'

export default class UpdateMailingMethodBlock extends EpiComponent<UpdateMailingMethodBlockData> {
  constructor(props) {
    super(props);

  }

  public render(): ReactNode | ReactNodeArray | null {

   return  <MailingMethodMain context={this.getContext()} iContent={this.props.data} />
  }
}
